var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "#475168"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 47C28.8425 47 27.515 48.3425 27.515 50C27.515 51.6575 28.8425 53 30.5 53C32.1575 53 33.5 51.6575 33.5 50C33.5 48.3425 32.1575 47 30.5 47ZM21.5 23V26H24.5L29.8925 37.3775L27.8675 41.0525C27.635 41.4875 27.5 41.975 27.5 42.5C27.5 44.1575 28.8425 45.5 30.5 45.5H48.5V42.5H31.1375C30.9275 42.5 30.7625 42.335 30.7625 42.125C30.7625 42.0575 30.7775 41.9975 30.8075 41.945L32.15 39.5H43.325C44.45 39.5 45.4325 38.8775 45.95 37.955L51.3125 28.22C51.4325 28.01 51.5 27.7625 51.5 27.5C51.5 27.1022 51.342 26.7206 51.0607 26.4393C50.7794 26.158 50.3978 26 50 26H27.8225L26.3975 23H21.5ZM45.5 47C43.8425 47 42.515 48.3425 42.515 50C42.515 51.6575 43.8425 53 45.5 53C47.1575 53 48.5 51.6575 48.5 50C48.5 48.3425 47.1575 47 45.5 47Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon1);
export default __webpack_public_path__ + "static/media/about-icon1.0cc5b337d22d410159b6f9445f3a0404.svg";
export { ForwardRef as ReactComponent };